import {ActionTypes, DataActionTypes} from './../../cc-imports'
import _ from 'lodash';
import {CCUtils, Constants} from "../../cc-imports";

const initialState = {
    byId: {},
    byUserId: {},

    pages: {},

    reqStatus: '',
    error: '',
    random: 0,
    type: DataActionTypes.GET
};


const processData = (oldState, newTrns, type, userId) => {

    const byId = _.keyBy(newTrns, 'id');
    var existingById = oldState.byId ? oldState.byId : [];
    existingById = _.merge({}, existingById, byId);

    var byUserId = CCUtils.groupByGetIds(newTrns, 'user', 'id');
    byUserId = _.mergeWith({}, byUserId, oldState.byUserId, CCUtils.customArrMerger)

    var pages = oldState.pages;
    //console.log("******************************* ", userId, type, newTrns, byUserId)

    if (userId) {

        var transactions = byUserId[userId];
        transactions = _.orderBy(transactions, [(transaction) => {
            if (existingById[transaction]) {
                return new Date(existingById[transaction].createdDate)
            }
            else {
                return new Date(-8640000000000000)
            }
        }], ['desc']);

        byUserId[userId] = transactions;
       // console.log("******************************* sorted", userId, type, newTrns)

        if (pages[userId] == undefined) {
            pages[userId] = 0;
        }
        if (type == DataActionTypes.PAGINATE || type == DataActionTypes.GET) {
            pages[userId] = pages[userId] + 1;
        }
    }

    return {
        byId: existingById,
        byUserId: byUserId,
        pages: pages
    }
};


const TransactionsReducers = (state = initialState, action = {}) => {

    switch (action.type) {
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_TRANSACTIONS)):

            return {
                ...state,
                reqStatus: Constants.reqStatus.SUC,
                type: action.meta.type,
                random: Math.random(),
                ...processData(state, action.payload.data.item, action.meta.type, action.meta.id)
            }
            break;

        case (ActionTypes.getFulfilled(ActionTypes.GET_TRANSACTIONS)):
            return {
                ...state,
                reqStatus: action.meta.type == DataActionTypes.PAGINATE ? Constants.reqStatus.COM : Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getPending(ActionTypes.GET_TRANSACTIONS)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.PEN,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_TRANSACTIONS)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;
        case ActionTypes.SIGN_OUT_USER:
            return initialState;
            break;
        case ActionTypes.CLOSE_MODAL:
            return {...state, pages: {}};
        default :
            return state;
    }
};

export default TransactionsReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/TransactionsReducers.js